<template>
  <div>
    <b-container v-if="!isNet">
      <b-row class="d-flex align-items-center text-center bg-danger" >
        <b-col cols=2>
          <b-icon icon="wifi-off" aria-hidden="true" scale="2" class="mx-2" variant="light"></b-icon>
        </b-col>
        <b-col>
          <p class="my-auto text-white"> Dispozitivul nu este conectat la internet! </p>
        </b-col>
      </b-row>
    </b-container>

    <b-jumbotron 
    v-if="deferredPrompt"
    fluid
    lead="Instalează aplicația"
    class="d-xl-none text-center my-0 py-2">
      <div class="d-flex justify-content-center">
        <b-button variant="secondary" @click="install" class='mr-3 py-1'>Instalează</b-button>
        <b-button variant="secondary" @click="dismiss" class='ml-3 py-1'>Renunță</b-button>
      </div>
    </b-jumbotron>
    <b-container fluid id="app" :class="mode">
      <Navbar :mode="mode" @toggle="toggle" />
      <router-view></router-view>
          <footer>
        <cookie-law theme="dark-lime">
            <div slot-scope="props">
                
                <p>
                    Pentru a imbunatati experienta vizitatorilor, folosim module cookies.
                    Prin continuarea navigarii pe site va exprimati acordul cu folosirea cookie-urilor. <a href="/pagina/termene-si-conditii">Detalii</a>
                </p>
                <b-button class="skew mr-2" @click="props.accept"><span>Accept</span></b-button> 
                <b-button class="skew ml-2" @click="props.close"><span>Refuz</span></b-button>
            </div>

        </cookie-law>
        
    </footer>
    <Offline @detected-condition="handleConnectivityChange"></Offline>
    </b-container>
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import Cookies from "js-cookie";
import CookieLaw from 'vue-cookie-law';
import Offline from  'v-offline';

export default {
  name: "App",
  components: {
    Navbar,
    CookieLaw,
    Offline
  },
  data() {
    return {
      mode: 'light',
      deferredPrompt: null,
      isNet: true,
    };
  },
  created() {
    this.mode = JSON.parse(localStorage.getItem("mode"));

    window.addEventListener("beforeinstallprompt", e => {
      e.preventDefault();
      // Stash the event so it can be triggered later.
      if (Cookies.get("add-to-home-screen") === undefined) {
        this.deferredPrompt = e;
      }
    });
    window.addEventListener("appinstalled", () => {
      this.deferredPrompt = null;
    });
  },
  methods: {
    handleConnectivityChange (status) {
            if (!status) { 
              this.isNet = false;
            } else {
              this.isNet = true;
            }
        },
    toggle() {
      if (this.mode === 'dark') {
        this.mode = 'light'
      } else {
        this.mode = 'dark'
      }
    },
    async dismiss() {
      Cookies.set("add-to-home-screen", null, { expires: 1 });
      this.deferredPrompt = null;

    },
    async install() {
      this.deferredPrompt.prompt();

    }
  },
  watch: {
    mode: function() {
      localStorage.setItem("mode", JSON.stringify(this.mode));
    }
  },
};
</script>
